import { render, staticRenderFns } from "./socialContract.vue?vue&type=template&id=e9bca526&scoped=true&"
import script from "./socialContract.vue?vue&type=script&lang=js&"
export * from "./socialContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bca526",
  null
  
)

export default component.exports